import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { isAuthenticatedAtom } from '../store';
import { api } from '../lib/api';
import { currentAppMode } from '../lib/installedApp';

// Once per page load, and again after each sign-in (D186). Module-level so
// StrictMode's double effects don't report twice.
let reported = false;

/** For tests. */
export function resetAppModeReport() {
  reported = false;
}

/**
 * Tells the server how this device opened Twinden: the installed app or a
 * browser tab (M53, D186). Mounted once, in App.
 */
export function useAppModeReport() {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  useEffect(() => {
    if (!isAuthenticated) {
      // Signed out: the next sign-in is a new session to report.
      reported = false;
      return;
    }
    if (reported) return;
    reported = true;
    // Counting only; a failure never troubles the person.
    api.reportAppMode(currentAppMode()).catch(() => undefined);
  }, [isAuthenticated]);
}
